import Search from '@phoenix/search/interfaces/Search';
import { clientApi } from '@phoenix/clientApi';
import { TAB_ALL } from '@maison/helpers/search-helper';
import { SearchResult } from '@phoenix/search/interfaces/SearchResultTypes';
import { SearchOptions } from '@phoenix/search/types';

let instance = null;

export default class PhoenixSearch implements Search {
  protected abortController?: AbortController;

  static getInstance(): PhoenixSearch {
    if (!instance) {
      instance = new PhoenixSearch();
    }

    return instance;
  }

  async performMainSearch(query: string, tab: string = TAB_ALL, options?: SearchOptions): Promise<SearchResult> {
    options = {
      page: 1,
      ...options,
    };

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    const isTabAll = tab === TAB_ALL;
    let endpoint = window.route('api.search.index');
    if (!isTabAll) {
      endpoint += `/${tab}`;
    }

    const { data } = await clientApi.get(endpoint, {
      params: { page: options.page, keyword: query },
      signal: this.abortController.signal,
    });

    if (data.hasOwnProperty('redirectUrl')) {
      return {
        type: 'redirect',
        redirectUrl: data.redirectUrl,
      };
    }

    if (isTabAll) {
      return {
        type: 'aggregated',
        results: data,
      };
    }

    return {
      type: 'data',
      ...data,
    };
  }

  async performSearch(query: string, options?: object): Promise<SearchResult> {
    return {
      type: 'aggregated',
      results: {},
    };
  }
}

export const phoenixSearch = PhoenixSearch.getInstance();
